interface MedicationIconProps {
  className?: string;
}

export function MedicationIcon({ className }: MedicationIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7793 0V6.39648H19.7031V27.5996H2.07715V6.39648H0V0H21.7793ZM3.50488 6.39648V9.10938H15.9658V22.959H3.50488V26.1719H18.2754V6.39648H3.50488ZM3.50488 10.5371V21.5312H14.5381V10.5371H3.50488ZM1.42773 1.42773V4.96875H20.3516V1.42773H1.42773Z"
        fill="currentColor"
      />
    </svg>
  );
}
